import { Spinner } from '@/components/loading'
import { FooterShell, HeaderShell } from '@/components/shells'
import { GlobalErrorPage } from '@/components/ui/errors'
import { useAuth } from '@/components/users/useAuth'
import { createRootRoute, Outlet, useLocation } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const Footer = lazy(() => import('@/components/footer').then(res => ({ default: res.Footer })))
const Header = lazy(() => import('@/components/header').then(res => ({ default: res.Header })))

export const Route = createRootRoute({
  component: RootRoute,
  errorComponent: GlobalErrorPage,
})

function RootRoute() {
  const { pathname } = useLocation()
  const { isAuthenticated } = useAuth()

  const isHideHeaderFooter = !isAuthenticated && pathname.startsWith('/auth')

  return (
    <main className="w-full bg-bgPage">
      {!isHideHeaderFooter && (
        <Suspense fallback={(
          <HeaderShell>
            <Spinner />
          </HeaderShell>
        )}
        >
          <Header />
        </Suspense>
      )}

      <Outlet />

      {!isHideHeaderFooter && (
        <Suspense fallback={(
          <FooterShell className="justify-center py-20">
            <Spinner />
          </FooterShell>
        )}
        >
          <Footer />
        </Suspense>
      )}
    </main>
  )
}
